import { API } from "@/lib/api";

// Avisa al equipo de que una pantalla se ha roto en el navegador de alguien
// (lo envía el ErrorBoundary). Solo mensaje, pila y ruta sin parámetros:
// nada de datos personales. Una vez por error y pantalla, como mucho 10 por
// visita; si falla el envío, silencio (no es asunto de quien usa la app).
const sent = new Set();

export function reportClientError(error, info) {
  try {
    const message = String(error?.message || error || "Error").slice(0, 500);
    const path = window.location.pathname;
    const key = `${path}|${message}`;
    if (sent.has(key) || sent.size >= 10) return;
    sent.add(key);
    fetch(`${API}/client-errors`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      keepalive: true,
      body: JSON.stringify({
        message,
        stack: String(error?.stack || "").slice(0, 4000),
        component_stack: String(info?.componentStack || "").slice(0, 2000),
        path,
      }),
    }).catch(() => {});
  } catch {
    // sin red o sin fetch: nada que hacer
  }
}
